import { i18n } from '@international/mastodon-i18n';
import { DateObject } from './interfaces';

export const selectYear = i18n.getStr(
  'components.Verification.EmploymentMultidocPanel.selectYear',
);
export const multiDocuments = 'multi_documents';
export const getSelectYearOption = () => [
  {
    value: selectYear,
    name: selectYear,
    uploadId: '',
    disabled: false,
  },
];
export const dateObject = (id: string, uploadId: string): DateObject => {
  return {
    id,
    uploadId,
    value: '',
    name: '',
    disabled: false,
    type: 'EmploymentProof',
    exceptionType: multiDocuments,
    requiredForVerification: false,
  };
};

export const ocrTypeMap: Record<string, string> = {
  w2: 'TaxFormW2',
  '1099': 'TaxForm1099',
  schedule_c: 'TaxFormScheduleC',
  paystub: 'Paystub',
  other: 'EmploymentProof',
};

export const emptyDocumentOption = {
  value: '',
  name: '',
  disabled: false,
  uploadId: '',
  requiredForVerification: false,
};

export const CANDIDATE_CONTEXT_MAX_LENGTH = 250; // mirrors the backend's own cap

export const defaultItem = {
  disabled: false,
  type: '',
  uploadId: '',
  requiredForVerification: true,
  // Reset clears the candidate-manual marker so a slot reused by a later OCR
  // auto-fill never inherits a stale `true`.
  candidateLabeled: false,
  candidateContext: '', // EVERI-4005: reset alongside candidateLabeled, same reason
  needsContext: false,
};
